module.exports = __webpack_public_path__ + "img/messe-bubbles.061f742.png";